import { Injectable } from '@angular/core';

@Injectable()
export class ModalScreenService {

  private message = '';



  constructor() {
  }


  show(message) {
    this.message = message;
  }


  hide() {
    this.show('');
  }


  getMessage() {
    return this.message;
  }
}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/modal-screen.service.ts